// React Router v7 official breadcrumbs using useMatches and handle
import { useMatches } from 'react-router-dom'
import { Link as NavLink } from 'react-router-dom'
import { Breadcrumbs as MUIBreadcrumbs, Typography, Box } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

export const Breadcrumbs = () => {
  const matches = useMatches()

  // Filter matches that have a crumb handle and create breadcrumbs
  const crumbs = matches
    .filter((match) => Boolean(match.handle?.crumb))
    .map((match) => ({
      label: match?.handle.crumb(match), // ✅ Pass entire match object instead of just match.data
      pathname: match.pathname,
    }))

  // Don't render if no breadcrumbs
  if (!crumbs.length) {
    return null
  }

  return (
    <Box display="flex">
      <Box>
        <MUIBreadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {crumbs.map((crumb, index) => {
            const isLast = index === crumbs.length - 1

            return isLast ? (
              <Typography key={index} color="textPrimary">
                {crumb.label}
              </Typography>
            ) : (
              <NavLink
                key={index}
                to={crumb.pathname}
                style={{
                  color: '#1976d2',
                  cursor: 'pointer',
                  textDecoration: 'none',
                }}
              >
                {crumb.label}
              </NavLink>
            )
          })}
        </MUIBreadcrumbs>
      </Box>
    </Box>
  )
}
